import { render, staticRenderFns } from "./ConvertPreEntryToActiveAction.vue?vue&type=template&id=ebc566c0&scoped=true"
import script from "./ConvertPreEntryToActiveAction.vue?vue&type=script&lang=js"
export * from "./ConvertPreEntryToActiveAction.vue?vue&type=script&lang=js"
import "./ConvertPreEntryToActiveAction.vue?vue&type=style&index=0&id=ebc566c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc566c0",
  null
  
)

export default component.exports